import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs';
import { Bind } from '@lms-approval/shared/core';
import { mountRootParcel } from 'single-spa';

import { SandboxMobileService } from '@lms-approval/onehub-sandbox';
import { SANDBOX_ROUTES } from '../../constants';
import { MicroFrontendService } from '../../services/micro-frontend.service';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'remote-loader',
  templateUrl: './remote-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoteLoaderComponent {
  readonly moduleConfig$ = this.sandboxMicroFrontendService.getModuleConfig$(
    this.configService.moduleName,
    this.configService.uniqueName,
  );
  readonly propsFromHost$ = this.sandboxMobileService.isMobileMode$.pipe(map(this.getPropsFromHost));
  readonly mountParcel = mountRootParcel;

  constructor(
    private sandboxMobileService: SandboxMobileService,
    private configService: ConfigService,
    private sandboxMicroFrontendService: MicroFrontendService,
  ) {}

  @Bind()
  private getPropsFromHost(isMobile: boolean): Record<string, unknown> {
    return this.sandboxMicroFrontendService.getRemoteProps({
      basename: SANDBOX_ROUTES.TRACKING,
      isInSandbox: true,
      isMobile,
    });
  }
}
